import React from 'react';
import { Icon, Row, Col, message } from 'antd';
import Page from '../../../lib/page';
import { Catalog } from '../../../component';
import env from '../../../lib/env';
import wandu from '../../../service/wandu';
import styles from './index.css';
import Cover from './cover';
import NovelReader from './novel_reader';
import ComicReader from './comic_reader';
import finish_pic from '../../../asset/book/finish.png';
import tbc_pic from '../../../asset/book/tbc.png';
import font_add_pic from '../../../asset/book/font_add.png';
import font_del_pic from '../../../asset/book/font_del.png';
import check_pic from '../../../asset/book/check.png';

const BookDone = () => (
    <div className={styles.done_panel}>
        <div><img alt='' src={finish_pic} /></div>
        <div>读完一本好书，又交一位益友!</div>
    </div>
);

const BookTBC = () => (
    <div className={styles.tbc_panel}>
        <div>作者努力码字中，后续章节很快更新</div>
        <div><img alt='' src={tbc_pic} /></div>
    </div>
);
export default class ReadPage extends Page {

    state = {
        chapter: null,
        skin: localStorage.getItem('skin') ? localStorage.getItem('skin') : 'yellow',
        show_catalog: false,
        reach_end: false,
        font_size: localStorage.getItem('font_size') ? Number(localStorage.getItem('font_size')) : 18,
        maxReadOrderNum: 20,
    }

    componentDidMount() {
        const calc_menu_offset = () => {
            const panel = document.getElementById("read_main");
            if (!panel) {
                return;
            }
            let offset_y = window.scrollY ? window.scrollY : window.pageYOffset;
            let diff = panel.offsetTop - offset_y;
            document.getElementById('read_left_menu').style.top = (diff > 0 ? diff + 'px' : 0);
            diff = diff + panel.offsetHeight - document.body.clientHeight;
            document.getElementById('read_right_menu').style.bottom = (diff > 0 ? 0 : -diff + 'px');
        }
        calc_menu_offset();
        window.onscroll = (e) => {
            calc_menu_offset();
        }
        window.onresize = (e) => {
            calc_menu_offset();
        }
        //禁止复制
        document.oncontextmenu = function (evt) {
            evt.preventDefault();
        }

        document.onselectstart = function (evt) {
            evt.preventDefault();
        };
        //防止直接进页面没加载广告出现定位错误
        setTimeout(calc_menu_offset, 300);
        const { novel_id, order_num } = this.props.match.params;
        this._load(novel_id, order_num);
    }

    componentWillUnmount() {
        //恢复复制
        document.oncontextmenu = "";
        document.onselectstart = true;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.match.params.novel_id !== this.props.match.params.novel_id
            || nextProps.match.params.order_num !== this.props.match.params.order_num) {
            this._load(nextProps.match.params.novel_id,
                nextProps.match.params.order_num);
            return false;
        }
        return true;
    }

    _load = (novel_id, order_num) => {
        return wandu.book_read({ novel_id, order_num }).then(res => {
            if (order_num !== undefined && Number(order_num) !== Number(res.order_num)) {
                //章节不存在
                this.goto_chapter(novel_id, res.order_num);
                return;
            }
            this.scroll_top();
            this.setState({
                chapter: res,
                reach_end: false,
                show_catalog: false,
            });
        }).catch(e => {
            console.log(e);
            env.goto_404();
        });
    }

    next_chapter = () => {
        const { novel_id, order_num } = this.props.match.params;
        console.log('ReadPage next_chapter',order_num);
        //如果下一章 不可阅读，就不做跳转
        if (Number(order_num) >= this.state.maxReadOrderNum) {
            return;
        }
        if (order_num === undefined) {
            this.goto_chapter(novel_id, this.state.chapter.order_num);
        } else if (Number(order_num) === Number(this.state.chapter.newest_order_num)) {
            this.setState({ reach_end: true });
        } else {
            if (this.state.chapter.next_order_num) {
                this.goto_chapter(novel_id, this.state.chapter.next_order_num);
            }
        }
    }

    prev_chapter = () => {
        const { novel_id, order_num } = this.props.match.params;
        console.log('ReadPage prev_chapter',order_num);
        if (this.state.reach_end) {
            this.setState({ reach_end: false });
            return;
        }
        if (this.state.chapter.prev_order_num) {
            this.goto_chapter(novel_id, this.state.chapter.prev_order_num);
        }
    }

    goto_chapter = (novel_id, order_num) => {
        this.scroll_top();
        env.goto_page(`/book/read/${novel_id}/${order_num}`);
    }

    font_size_add = () => {
        if (this.state.font_size >= 24) {
            return;
        }
        this.setState({
            font_size: this.state.font_size + 1,
        }, () => localStorage.setItem('font_size', this.state.font_size));
    }

    font_size_del = () => {
        if (this.state.font_size <= 12) {
            return;
        }
        this.setState({
            font_size: this.state.font_size - 1,
        }, () => localStorage.setItem('font_size', this.state.font_size));
    }

    change_skin = (skin) => {
        this.setState({ skin });
        localStorage.setItem('skin', skin);
    }

    is_comic = () => {
        if (this.state.chapter && this.state.chapter.novelInfo
            && this.state.chapter.novelInfo.type === '2') {
            return true;
        } else {
            return false;
        }
    }

    add_collect = () => {
        if (!this.state.chapter) {
            return;
        }
        if (this.state.chapter.is_collect) {
            message.info('已在书架');
            return;
        }
        const { novel_id } = this.props.match.params;
        wandu.add_collect({ novel_id }).then(res => {
            this.state.chapter.is_collect = true;
            message.info('添加书架成功');
            this.setState({});
        }).catch(e => {
            console.log(e);
        });
    }

    render() {
        let content = null;
        if (this.state.chapter) {
            if (this.state.reach_end) {
                if (Number(this.state.chapter.novelInfo.is_done)) {
                    content = <BookDone />;
                } else {
                    content = <BookTBC />;
                }
            } else {
                if (this.props.match.params.order_num === undefined) {
                    content = <Cover {...this.state.chapter.novelInfo} />;
                } else if (this.is_comic()) {
                    content = <ComicReader {...this.state.chapter} />;
                } else {
                    const BgBtn = ({ name, color }) => {
                        if (this.state.skin === name) {
                            return (
                                <div className={styles.font_btn} style={{
                                    backgroundImage: `url(${check_pic})`,
                                }} />
                            );
                        } else {
                            return (
                                <div className={styles.bg_btn} style={{
                                    background: color,
                                }} onClick={this.change_skin.bind(this, name)} />
                            );
                        }
                    };
                    content = (
                        <NovelReader font_size={this.state.font_size} {...this.state.chapter}>
                            <div style={{
                                position: 'absolute',
                                right: '52px',
                                top: '67px',
                            }}>
                                <BgBtn name='white' color='#f6f6f8' />
                                {/* <BgBtn name='yellow' color='#e4dac8' /> */}
                                <BgBtn name='yellow' color='#E6FBD2' />
                                <BgBtn name='black' color='#4b4b4d' />
                                <div className={styles.font_btn} style={{
                                    backgroundImage: `url(${font_add_pic})`,
                                }} onClick={this.font_size_add} />
                                <div className={styles.font_btn} style={{
                                    backgroundImage: `url(${font_del_pic})`,
                                }} onClick={this.font_size_del} />
                            </div>
                        </NovelReader>
                    );
                }
            }
        }
        const { novel_id, order_num } = this.props.match.params;
        const prev_btn_enable = (order_num !== undefined && this.state.chapter
            && Number(order_num) !== Number(this.state.chapter.oldest_order_num));
        return (
            <div style={{ width: '1000px', margin: '0 auto' }} className={this.is_comic() ? styles.comic : styles[this.state.skin]}>
                <div id='read_main' className={styles.main}>{content}</div>
                <Row style={{
                    position: 'relative',
                    width: '800px',
                    margin: '20px auto 0 auto',
                }}>
                    <Col
                        span={8}
                        className={(prev_btn_enable ? styles.bottom_menu_active : styles.bottom_menu_inactive)}
                        onClick={this.prev_chapter}><span>上一章</span></Col>
                    <Col
                        span={8}
                        className={styles.bottom_menu_active}
                        onClick={() => { this.setState({ show_catalog: true }) }}><span>目录</span></Col>
                    <Col
                        span={8}
                        className={(this.state.reach_end || Number(order_num) >= this.state.maxReadOrderNum) ? styles.bottom_menu_inactive : styles.bottom_menu_active}
                        onClick={this.next_chapter}><span>下一章</span></Col>
                    <div className={styles.divider} style={{ left: '33.3%' }} />
                    <div className={styles.divider} style={{ right: '33.3%' }} />
                </Row>
                <div id='read_left_menu' style={{
                    position: 'fixed',
                    left: '50%',
                    marginLeft: '-500px',
                }}>
                    {/* <div className={styles.left_menu} onClick={this.add_collect}>
                    {(this.state.chapter && this.state.chapter.is_collect) ? '已在书架' : '+书架'}
                </div> */}
                    <div className={styles.left_menu} onClick={() => {
                        this.setState({ show_catalog: true });
                    }}>目录</div>
                    <div className={styles.left_menu} onClick={() => {
                        env.goto_page(`/book/detail/${novel_id}`)
                    }}>详情</div>
                </div>
                <div id='read_right_menu' style={{
                    position: 'fixed',
                    right: '50%',
                    marginRight: '-500px',
                }}>
                    <div className={styles.right_menu} onClick={this.scroll_top}><Icon type='to-top' /></div>
                    <div className={(this.state.reach_end || Number(order_num) >= this.state.maxReadOrderNum) ? styles.right_menu_inactive : styles.right_menu}
                        onClick={this.next_chapter}>下一章
                    </div>
                </div>
                <Catalog
                    show={this.state.show_catalog}
                    onCancel={() => {
                        this.setState({ show_catalog: false });
                    }}
                    onCallback={(tempOrderNum) => {
                        this.setState({ maxReadOrderNum: tempOrderNum });
                    }}
                    novel_id={novel_id}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/read/index.js